module.exports = __webpack_public_path__ + "img/31.e78eb356.jpg";